import React from 'react';
import { DeviceControlUnitsAPIResponse } from '../../../../redux/commander/api/device.model';
import ControlUnitsListGrid from './ControlUnitListGrid';

export interface ControlUnitsListProps {
  controlUnits: DeviceControlUnitsAPIResponse[] | undefined;
  deviceId: string;
  groupId?: string;
}

function ControlUnitsList(props: ControlUnitsListProps) {
  return <ControlUnitsListGrid {...props} />;
}

export default ControlUnitsList;
